import { isHdl } from '@haidilao-private/jsbridge';

/**
 * @description: 计算像素
 * @param {number} num
 * @return {*}
 */
export const $vw = function (num: number) {
  return (num / 390) * 100 + 'vw';
};

/**
 * @description:判断环境
 * env ： app   mini小程序    wx
 */
export function isEnv() {
  if (isHdl) {
    return 'App';
  }
  // return 'H5';
  return 'App';
}

// 端外 设置导航栏标题（微信）
export const setDocumentTitle = (title: string) => {
  try {
    const document = window.document;
    document.title = title;
  } catch (err) {
    console.log(err);
  }
};
